import { render, staticRenderFns } from "./SendingProviders.vue?vue&type=template&id=96c60776&"
import script from "./SendingProviders.vue?vue&type=script&lang=js&"
export * from "./SendingProviders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports